import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Dispatch } from '@Redux/type';
import { AppState } from '@Redux/store';
import {
  AdvancedMarker,
  InfoWindow,
  useAdvancedMarkerRef,
} from '@vis.gl/react-google-maps';
import { ClubView } from '@Selectors/federation/view/club.view';
import ReactCountryFlag from 'react-country-flag';

interface IMarkerComponentProps {
  club: ClubView;
  selected: boolean;
  onClick: (club: ClubView) => void;
  onClose: () => void;
}

const ClubMarkerComponent: React.FC<Props> = ({
  club,
  selected,
  onClick,
  onClose,
}) => {
  const [infowindowOpen, setInfowindowOpen] = useState(selected);
  const [markerRef, marker] = useAdvancedMarkerRef();

  const toggleInfowindow = () => {
    setInfowindowOpen(!infowindowOpen);
    onClick(club);
  };
  const closeInfowindow = () => {
    setInfowindowOpen(false);
    onClose();
  };
  return (
    <>
      <AdvancedMarker
        ref={markerRef}
        onClick={() => toggleInfowindow()}
        position={{ lat: club.latitude, lng: club.longitude }}
        title={club.name}
      />
      {(infowindowOpen || selected) && (
        <InfoWindow
          anchor={marker}
          maxWidth={300}
          headerContent={
            <>
              <ReactCountryFlag countryCode={club.country} /> {club.name}
            </>
          }
          onCloseClick={closeInfowindow}
        >
          {club.notes && (
            <p>{club.notes}</p>
          )}
          {club.location && (
            <p>
              <u>
                <b>Location:</b>
              </u>{' '}
              {club.location}
            </p>
          )}
          {club.contact && (
            <p>
              <u>
                <b>Contact:</b>
              </u>{' '}
              {club.contact}
            </p>
          )}
          {club.members && (
            <p>
              <u>
                <b>Members:</b>
              </u>{' '}
              {club.members}
            </p>
          )}
          {club.meets && (
            <p>
              <u>
                <b>Meetings:</b>
              </u>{' '}
              {club.meets}
            </p>
          )}
        </InfoWindow>
      )}
    </>
  );
};

const mapStateToProps = (_: AppState, props: IMarkerComponentProps) => ({
  club: props.club,
  onClick: props.onClick,
  selected: props.selected,
  onClose: props.onClose,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ClubMarkerComponent);

type Props = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps> &
  IMarkerComponentProps;
